module.exports = __webpack_public_path__ + "img/icon-envelope2.7b89c05b.svg";